<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nombre</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el nombre del Promotor"
                v-model.trim="company.name"
                @input="clearError('name')"
              />
              <div class="input-error">{{ errors.name }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">RUC</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el RUC del Promotor"
                v-model.trim="company.ruc"
                  maxlength="11"
                @input="clearError('ruc')"
              />
              <div v-if="errors.ruc" class="input-error">{{ errors.ruc }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Descripción</label>
              <textarea
                rows="4"
                style="resize: none"
                class="form-control text-dark no-resize"
                placeholder="Ingresar la descripción del Promotor"
                v-model.trim="company.description"
                @input="clearError('description')"
              ></textarea>
              <div v-if="errors.description" class="input-error">
                {{ errors.description }}
              </div>
            </div>
          </div>
          
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">
              <RouterLink to="/promotors">
                <button
                  type="button"
                  class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                >
                  Cancelar
                </button>
              </RouterLink>
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading">{{
                  company.id == 0 ? "Crear" : "Actualizar"
                }}</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { promotorSchema } from "@/schemas/promotorSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import {COMPANY_TYPES}  from "@/utils/constants";

export default defineComponent({
  name: "CreatePromotor",
  components: {},
  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);

    const itemsCompanyTypes = ref<any[]>([]);
    const company = ref({
      id: 0,
      companyTypeId: COMPANY_TYPES.PROMOTOR,
      name: null,
      description: null,
      ruc: null,
      flagCompany:false
    });
    const errors = ref<Record<string, string>>({});

    onMounted(async () => {
      await getCompanyTypes();
      var id = route.params.id;
      if (id) {
        await getCompanyById(id);
      }
    });

    const getCompanyTypes = async () => {
      try {
        const response = await api.get(`/common/company-types`);
        itemsCompanyTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const validateForm = async () => {
      try {
        errors.value = {};
        await promotorSchema.validate(company.value, {
          abortEarly: false,
          context: {
            id: company.value.id,
            companyTypeId: company.value.companyTypeId,
            ruc: company.value.ruc,
          },
        });
        isLoading.value = true;

        await createCompany();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const getCompanyById = async (id: any) => {
      try {
        const response = await api.get(`/company/${id}`);
        company.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const createCompany = async () => {
      try {
        const response: any = await api.post(`/company`, company.value);
        if (response.data != 0) {
          toast.success(
            `El Promotor fue ${
              company.value.id == 0 ? "creado" : "actualizado"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );

          router.push({ name: "PromotorsPage" });
        }
      } catch (ex) {
        toast.error("El Promotor no pudo ser creado.", {
          timeout: 2000,
        });
        console.error(ex);
      }
    };

    return {
      createCompany,
      validateForm,
      clearError,
      company,
      itemsCompanyTypes,
      errors,
      isLoading,
    };
  },
});
</script>
